interface DividerProps {
  customStyle?: string;
}

export const Divider = ({ customStyle }: DividerProps) => {
  return (
    <div
      className={`w-full border border-solid border-gray-light ${customStyle}`}
    />
  );
};
